export const normalizeStringToCompare = (str: string): string => {
  return str
    .trim()
    .toLocaleLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
};
